module.exports = __webpack_public_path__ + "static/media/image.94d80ec5.png";